import React from "react";

interface PropTypes {
    title?: string;
    summary?: string;
    uploadDate?: Date;
    embedUrl?: string;
    thumbnailUrl?: string;
}

/**
 * Loads the Video Schema script.
 *
 */
const VideoSchema: React.FunctionComponent<PropTypes> = ({
    title,
    summary,
    uploadDate,
    embedUrl,
    thumbnailUrl,
}: PropTypes): JSX.Element => {
    const ldJson = {
        "@context": "https://schema.org/",
        "@type": "VideoObject",
        name: title,
        description: summary,
        uploadDate: uploadDate,
        embedUrl: embedUrl,
        thumbnailUrl: thumbnailUrl,
    };

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(ldJson).replace("&quot;", `"`) }}
        ></script>
    );
};

export default VideoSchema;
